import React, {useEffect} from 'react';
import {useUnit} from 'effector-react';
import {$appStore, hideToast} from '@/core/store/app';
import {Toast} from '../toast/Toast';
import './ToastManager.scss';

export const ToastManager: React.FC = () => {
  const appState = useUnit($appStore);
  const toasts = appState.toasts;


  useEffect(() => {
    const timeouts: Record<string, NodeJS.Timeout> = {};

    toasts.forEach((toast) => {
      if (!timeouts[toast.id]) {
        timeouts[toast.id] = setTimeout(() => {
          hideToast(toast.id);
          delete timeouts[toast.id];
        }, toast.duration);
      }
    });

    return () => {
      Object.values(timeouts).forEach(clearTimeout);
    };
  }, [toasts]);

  const handleCloseToast = (toastId: string) => {
    hideToast(toastId);
  };

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="toast-manager">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          type={toast.type}
          text={toast.text}
          onClose={() => handleCloseToast(toast.id)}
        />
      ))}
    </div>
  );
};